import {
  definitionOfEarningsSpec,
  maximumAmountSpec,
  rateGuarantee,
} from "./sharedTypedAmount";

import type {
  TypedAmountSpec,
  TypedAmountTypeOption,
} from "../typedAmountTypes";

const NOT_INCLUDED: TypedAmountTypeOption = {
  value: "notIncluded",
  label: "Not Included",
  hideAmount: true,
};
const NOT_DISCLOSED: TypedAmountTypeOption = {
  value: "notDisclosed",
  label: "Not Disclosed",
  hideAmount: true,
};
const NOT_OFFERED: TypedAmountTypeOption = {
  value: "notOffered",
  label: "Not Offered",
  hideAmount: true,
};

export const stdTypedAmountFields: Record<string, TypedAmountSpec> = {
  maximumAmount: maximumAmountSpec,
  eliminationPeriodAccident: {
    typeKey: "eliminationPeriodAccidentType",
    amountKey: "eliminationPeriodAccidentDays",
    amountLabel: "Number of Days",
    typeOptions: [
      { value: "days", label: "Days" },
      NOT_INCLUDED,
      NOT_DISCLOSED,
      NOT_OFFERED,
    ],
  },
  eliminationPeriodIllness: {
    typeKey: "eliminationPeriodIllnessType",
    amountKey: "eliminationPeriodIllnessDays",
    amountLabel: "Number of Days",
    typeOptions: [
      { value: "days", label: "Days" },
      NOT_INCLUDED,
      NOT_DISCLOSED,
      NOT_OFFERED,
    ],
  },
  benefitDuration: {
    typeKey: "benefitDurationType",
    amountKey: "benefitDurationAmount",
    amountLabel: "Amount",
    typeOptions: [
      { value: "days", label: "Days" },
      { value: "weeks", label: "Weeks" },
      NOT_INCLUDED,
      NOT_DISCLOSED,
      NOT_OFFERED,
    ],
  },
  definitionOfEarnings: definitionOfEarningsSpec,
  rateGuarantee,
  // Extended (non-v5) field (CD-2552). Values mirror
  // shared/cellSpecs/dropdownCellSpecs.ts's minimumBenefitTypeValues.
  minimumBenefit: {
    typeKey: "minimumBenefitType",
    amountKey: "minimumBenefitAmount",
    amountLabel: "Amount",
    typeOptions: [
      { value: "dollarAmount", label: "Dollar Amount" },
      {
        value: "percentageOfSalary",
        label: "Percentage of Salary",
        amountMax: 100,
      },
      NOT_DISCLOSED,
    ],
  },
};
